export type OptionType = {
  id: string
  label: string
}

export const OptionTypeEmpty = {
  id: '',
  label: '',
}
